import React, { Component } from 'react'
import { observer } from 'mobx-react'
import withStyles, { ThemeProvider } from 'react-jss'
import classNames from 'classnames'
import { getLinkByParams } from 'utils/embeddableItems.utils'

import embeddableItemStyles from '../embeddableItemStyles'

@observer
class Button extends Component {
  render() {
    const {
      productLink,
      productLink: { embedPrefs, product },
      classes,
    } = this.props
    const butonClass = classNames(classes.button, classes[embedPrefs.buttonAnimation])
    return (
      <div style={{ display: 'inline-block' }}>
        <button className={butonClass} onClick={() => window.open(getLinkByParams(productLink, product))}>
          {embedPrefs.buttonText}
        </button>
      </div>
    )
  }
}

const StyledButton = withStyles(embeddableItemStyles)(Button)

const ButtonContainer = (props) => (
  <ThemeProvider theme={props.productLink.embedPrefs}>
    <StyledButton {...props} />
  </ThemeProvider>
)

export default ButtonContainer
